'use strict';

module.exports = {
	strokes: (name, width) => {
		if (!name || name === 'solid') {
			return '';
		}
		const multipleWidth = Math.max(width || 1, 1) * 4;
		if (name === 'dashed') {
			return [multipleWidth, multipleWidth].join(', ');
		} else {
			return [1, multipleWidth].join(', ');
		}
	},
	linecap: (name) => {
		if (!name || name === 'solid') {
			return 'square';
		}
		if (name === 'dotted') {
			return 'round';
		}
		return '';
	}

};
